import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { auth } from "firebase";
import { Subscription } from "rxjs";
import { Library } from "../../interfaces/firebase-interfaces";
import { FirebaseService } from "../../services/firebase.service";
import { HelperService } from "../../services/helper.service";

@Component({
  selector: "libraries",
  templateUrl: "./libraries.page.html",
  styleUrls: ["./libraries.page.scss"],
})
export class LibrariesPage implements OnInit, OnDestroy {
  Libraries: (Library & { subscribed: boolean })[] = [];
  searchTerm: string;
  searching: boolean = false;

  guestMode: boolean = false;

  subscriptions: Subscription[] = [];

  constructor(public router: Router, private fireServ: FirebaseService, public helperServ: HelperService) {}

  async ngOnInit() {
    auth().onAuthStateChanged((user) => {
      if (user && (user.emailVerified || user.phoneNumber)) {
        this.guestMode = false;
        this.getContent();
      } else {
        this.guestMode = true;
        return;
      }
    });
  }

  ngOnDestroy(): void {
    this.destorySubs();
  }

  destorySubs() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  async getContent() {
    this.fireServ.getSubscribedContent().then((subs) => {
      if (subs.length > 0) {
        this.helperServ.presentLoader();
        console.log("subs", subs);
        this.fireServ.getLibraries([["id", "in", subs]]).subscribe(
          (libraries) => {
            this.Libraries = libraries.map((lib) => {
              return { ...lib, subscribed: true };
            });
          },
          () => {
            console.log("error");
          },
          () => {
            this.helperServ.dismissLoader();
          }
        );
      }
    });
  }

  search() {
    console.log(this.searchTerm);
    if (!this.searchTerm || this.searchTerm.length < 3) {
      this.helperServ.presentToast("Please enter 3 or more characters");
      return;
    }

    this.router.navigate(["search-results"], { queryParams: { search_query: this.searchTerm } });
  }

  async handleRefresh(event) {
    this.destorySubs();
    await this.getContent();
    event.target.complete();
  }
}
